// packages/world-model/src/traits/openable/index.ts

export * from './openableTrait.js';
export * from './openableBehavior.js';